import * as React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import {
  isInclusivelyAfterDay,
  OpenDirectionShape,
  SingleDatePicker,
} from "react-dates";
import { useSession } from "@hooks";
import { useMediaQuery } from "@mui/material";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "./SDPicker.css";
import "moment/locale/fr";

type SDPickerProps = {
  selectedSingleDate: moment.Moment | null;
  setSelectedSingleDate: (e: moment.Moment | null) => void;
  isRequired?: boolean;
  occupantGuiid?: number;
  isOutsideRange?: ((day: moment.Moment) => boolean) | undefined;
  disabled?: boolean;
};

const SDPicker: React.FC<SDPickerProps> = ({
  selectedSingleDate,
  setSelectedSingleDate,
  isRequired = false,
  occupantGuiid,
  isOutsideRange,
  disabled,
}) => {
  const matches = useMediaQuery("(max-width:768px)");

  const { getLanguageVarValue, lang } = useSession();
  moment.locale(lang.toLowerCase());

  React.useState<moment.Moment | null>(moment(new Date()));
  const [focused, setFocused] = React.useState<boolean>(false);
  const [direction, setDirection] = React.useState<OpenDirectionShape>("down");

  const renderMonthElement = ({ month, onMonthSelect, onYearSelect }: any) => {
    let i;
    let years = [];
    for (i = moment().year(); i >= moment().year() - 100; i--) {
      years.push(
        <option value={i} key={`year-${i}`}>
          {i}
        </option>
      );
    }
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="tw-pl-3">
          <select
            value={month.month()}
            onChange={(e) => onMonthSelect(month, e.target.value)}
            className="focus:tw-outline-none"
          >
            {moment.months().map((label, value) => (
              <option value={value} key={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <select
            value={month.year()}
            onChange={(e) => onYearSelect(month, e.target.value)}
            className="focus:tw-outline-none"
          >
            {years}
          </select>
        </div>
      </div>
    );
  };

  const handleScroll = () => {
    const element = occupantGuiid
      ? document.getElementById(`sdr_SingleDatePicker_${occupantGuiid}`)
      : document.getElementById("sdr_SingleDatePicker");
    if (element) {
      const rect = element.getBoundingClientRect();
      if (rect?.top < 0) {
        setDirection("up");
      } else if (rect?.top >= 300) {
        setDirection("up");
      } else if (rect?.top < 100) {
        setDirection("down");
      }
    }
  };

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    // Nettoie l'écouteur d'événements lors du démontage du composant

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="rsl_sdr tw-w-full">
      <SingleDatePicker
        focused={focused}
        onFocusChange={({ focused }) => {
          setFocused(focused);
          handleScroll();
        }}
        disabled={disabled}
        required={isRequired}
        renderMonthElement={renderMonthElement}
        date={selectedSingleDate}
        onDateChange={(e) => setSelectedSingleDate(e)}
        id={
          occupantGuiid
            ? `sdr_SingleDatePicker_${occupantGuiid}`
            : `sdr_SingleDatePicker`
        }
        placeholder={`${getLanguageVarValue("LANG_neobooking_birthdate")}*`}
        readOnly
        withFullScreenPortal={matches}
        numberOfMonths={1}
        block
        openDirection={direction}
        hideKeyboardShortcutsPanel={true}
        isOutsideRange={
          isOutsideRange
            ? isOutsideRange
            : (day) => isInclusivelyAfterDay(day, moment())
        }
      />
    </div>
  );
};

SDPicker.propTypes = {
  //
};

export default SDPicker;
